import BisualFarmaScreen from './BisualFarmaScreen'

export default BisualFarmaScreen
